module.exports = __webpack_public_path__ + "img/1543208459.936cdff4.jpg";